import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApplicationType, LookupsType } from '../../common';
import { LookUpsApi } from '../api/lookups-api';
import { BasicUser, Category, LookupModel } from '../model';
import { Program } from '../model/program-model';
import { Repository } from './repository';
import { InsolventsQueryRequestForm, StudentsQuerySendMessageForm } from 'src/app/shared/interfaces';
import { EjazaModel } from '../model/ejaza-model';
import { planLearningObjectives } from '../model/learning-objectives';
import { SessionSlotsModel } from '../model/session-slots-model';

@Injectable({
  providedIn: 'root',
})
export class LookUpsRepository extends Repository {
  constructor(private lookUpsApi: LookUpsApi) {
    super();
  }
  getCategories(pageIndex: number, pageSize: number): Observable<Category[]> {
    return this.lookUpsApi.getCategories(pageIndex, pageSize);
  }

  getLookUps(type: LookupsType): Observable<LookupModel[]> {
    return this.lookUpsApi.getLookUps(type);
  }

  getPrograms(pageIndex: number, pageSize: number): Observable<Program[]> {
    return this.lookUpsApi.getPrograms(pageIndex, pageSize);
  }

  getStudentsQuery(form: StudentsQuerySendMessageForm, appName?: ApplicationType): Observable<BasicUser[]> {
    return this.lookUpsApi.getStudentsQuery(form, appName);
  }

  getTeachersQuery(fullName: string): Observable<BasicUser[]> {
    return this.lookUpsApi.getTeachersQuery(fullName);
  }

  getInsolventsQuery(form: InsolventsQueryRequestForm): Observable<BasicUser[]> {
    return this.lookUpsApi.getInsolventsQuery(form);
  }

  getTeacherEjazat(): Observable<EjazaModel[]> {
    return this.lookUpsApi.getTeacherEjazat();
  }

  getLearningObjective(): Observable<planLearningObjectives[]> {
    return this.lookUpsApi.getLearningObjective();
  }

  getSessionSlots(): Observable<SessionSlotsModel[]> {
    return this.lookUpsApi.getSessionSlots();
  }

  getApplicationCategories(applicationTypes: ApplicationType[]): Observable<Category[]> {
    return this.lookUpsApi.getApplicationCategories(applicationTypes);
  }
}
